import type { LinkListItem } from '~/components/LinkList';
import type { NavigationSectionItem } from '~/components/NavigationSection';
import type { RouteLocationRaw } from 'vue-router';

import { FeatureEnum, PropertyTypeEnum } from '~/core/entities/CRMEnums';
import { PropertyFiltersPresenter } from '~/presenters/PropertyFiltersPresenter';
import { regions } from '~~/data/regions/';

// TODO: esses dados ainda não estão sendo usados, quando formos usar, vamos precisar ajustar alguns detalhes
export const exploredRegions: LinkListItem[] = [
	{
		name: regions.ipiranga?.name as string,
		image: regions.ipiranga?.image,
		route: { path: PropertyFiltersPresenter.DEFAULT_URL_PATH },
		links: [
			{
				label: 'Itaim Bibi',
				route: PropertyFiltersPresenter.getRouteObjectFromFilters({
					states: ['SP'],
					cities: ['São Paulo'],
					regions: ['Itaim Bibi']
				})
			},
			{
				label: 'Pinheiros',
				route: PropertyFiltersPresenter.getRouteObjectFromFilters({
					states: ['SP'],
					cities: ['São Paulo'],
					regions: ['Pinheiros']
				})
			},
			{
				label: 'Jardim Paulista',
				route: PropertyFiltersPresenter.getRouteObjectFromFilters({
					states: ['SP'],
					cities: ['São Paulo'],
					regions: ['Jardim Paulista']
				})
			},
			{
				label: 'Moema',
				route: PropertyFiltersPresenter.getRouteObjectFromFilters({
					states: ['SP'],
					cities: ['São Paulo'],
					regions: ['Moema']
				})
			},
			{
				label: 'Ipiranga',
				route: PropertyFiltersPresenter.getRouteObjectFromFilters({
					states: ['SP'],
					cities: ['São Paulo'],
					regions: ['Ipiranga']
				})
			}
		]
	},
	{
		name: regions.pinheiros?.name as string,
		image: regions.pinheiros?.image,
		route: { path: PropertyFiltersPresenter.DEFAULT_URL_PATH },
		links: [
			{
				label: 'Vila Nova Conceição',
				route: PropertyFiltersPresenter.getRouteObjectFromFilters({
					states: ['SP'],
					cities: ['São Paulo'],
					regions: ['Vila Nova Conceição']
				})
			},
			{
				label: 'Jardim Paulistano',
				route: PropertyFiltersPresenter.getRouteObjectFromFilters({
					states: ['SP'],
					cities: ['São Paulo'],
					regions: ['Jardim Paulistano']
				})
			},
			{
				label: 'Vila Madalena',
				route: PropertyFiltersPresenter.getRouteObjectFromFilters({
					states: ['SP'],
					cities: ['São Paulo'],
					regions: ['Vila Madalena']
				})
			},
			{
				label: 'Vila Olímpia',
				route: PropertyFiltersPresenter.getRouteObjectFromFilters({
					states: ['SP'],
					cities: ['São Paulo'],
					regions: ['Vila Olímpia']
				})
			},
			{
				label: 'Pacaembu',
				route: PropertyFiltersPresenter.getRouteObjectFromFilters({
					states: ['SP'],
					cities: ['São Paulo'],
					regions: ['Pacaembu']
				})
			}
		]
	},
	{
		name: regions['itaim-bibi']?.name as string,
		image: regions['itaim-bibi']?.image,
		route: PropertyFiltersPresenter.getRouteObjectFromFilters({
			states: ['sp'],
			cities: ['São Paulo'],
			regions: ['Itaim Bibi']
		}),
		links: [
			{
				label: 'Jardim Europa',
				route: PropertyFiltersPresenter.getRouteObjectFromFilters({
					states: ['sp'],
					cities: ['São Paulo'],
					regions: ['Jardim Europa']
				})
			},
			{
				// TODO: esse bairro vai ser permitido no portal?
				label: 'Moema Pássaros',
				route: PropertyFiltersPresenter.getRouteObjectFromFilters({
					states: ['sp'],
					cities: ['São Paulo'],
					regions: ['Moema Pássaros']
				})
			},
			{
				label: 'Brooklin',
				route: PropertyFiltersPresenter.getRouteObjectFromFilters({
					states: ['sp'],
					cities: ['São Paulo'],
					regions: ['Brooklin']
				})
			},
			{
				label: 'Higienópolis',
				route: PropertyFiltersPresenter.getRouteObjectFromFilters({
					states: ['sp'],
					cities: ['São Paulo'],
					regions: ['Higienópolis']
				})
			},
			{
				// TODO: o que vai aparecer no lugar desse bairro?
				label: 'Bairro',
				route: { path: PropertyFiltersPresenter.DEFAULT_URL_PATH }
			}
		]
	},
	{
		name: regions.moema?.name as string,
		image: regions.moema?.image,
		route: { path: PropertyFiltersPresenter.DEFAULT_URL_PATH },
		links: [
			{
				label: 'Jardim América',
				route: { path: PropertyFiltersPresenter.DEFAULT_URL_PATH }
			},
			{
				label: 'Moema Índios',
				route: { path: PropertyFiltersPresenter.DEFAULT_URL_PATH }
			},
			{
				label: 'Alto de Pinheiros',
				route: { path: PropertyFiltersPresenter.DEFAULT_URL_PATH }
			},
			{
				label: 'Bairro',
				route: { path: PropertyFiltersPresenter.DEFAULT_URL_PATH }
			},
			{
				label: 'Morumbi',
				route: { path: PropertyFiltersPresenter.DEFAULT_URL_PATH }
			}
		]
	}
];

// TODO: esses dados ainda não estão sendo usados, quando formos usar, vamos precisar ajustar alguns detalhes
export const interestedProperties: LinkListItem[] = [
	{
		name: 'Cidades',
		links: [
			{
				label: 'São Paulo, SP',
				route: PropertyFiltersPresenter.getRouteObjectFromFilters({
					states: ['sp'],
					cities: ['São Paulo']
				})
			},
			{
				label: 'Barueri',
				route: PropertyFiltersPresenter.getRouteObjectFromFilters({
					states: ['sp'],
					cities: ['Barueri']
				})
			},
			{
				label: 'Santos',
				route: PropertyFiltersPresenter.getRouteObjectFromFilters({
					states: ['sp'],
					cities: ['Santos']
				})
			},
			{
				label: 'Campinas',
				route: PropertyFiltersPresenter.getRouteObjectFromFilters({
					states: ['sp'],
					cities: ['Campinas']
				})
			},
			{
				label: 'São Caetano do Sul',
				route: PropertyFiltersPresenter.getRouteObjectFromFilters({
					states: ['sp'],
					cities: ['São Caetano do Sul']
				})
			}
		]
	},
	{
		name: 'Bairros',
		links: [
			{
				label: 'Itaim Bibi, São Paulo',
				route: PropertyFiltersPresenter.getRouteObjectFromFilters({
					states: ['SP'],
					cities: ['São Paulo'],
					regions: ['Itaim Bibi']
				})
			},
			{
				label: 'Pinheiros, São Paulo',
				route: PropertyFiltersPresenter.getRouteObjectFromFilters({
					states: ['SP'],
					cities: ['São Paulo'],
					regions: ['Pinheiros']
				})
			},
			{
				label: 'Vila Madalena, São Paulo',
				route: PropertyFiltersPresenter.getRouteObjectFromFilters({
					states: ['SP'],
					cities: ['São Paulo'],
					regions: ['Vila Madalena']
				})
			},
			{
				label: 'Moema, São Paulo',
				route: PropertyFiltersPresenter.getRouteObjectFromFilters({
					states: ['SP'],
					cities: ['São Paulo'],
					regions: ['Moema']
				})
			},
			{
				label: 'Ipiranga, São Paulo',
				route: PropertyFiltersPresenter.getRouteObjectFromFilters({
					states: ['SP'],
					cities: ['São Paulo'],
					regions: ['Ipiranga']
				})
			}
		]
	},
	{
		// TODO: como vamos aplicar filtros de rua?
		name: 'Ruas',
		links: [
			{
				label: 'Rua Oscar Freire, Itaim Bibi',
				route: { path: PropertyFiltersPresenter.DEFAULT_URL_PATH }
			},
			{
				label: 'Rua Oscar Freire, Jardins',
				route: { path: PropertyFiltersPresenter.DEFAULT_URL_PATH }
			},
			{
				label: 'Rua Antônio de Albuquerque, Perdizes',
				route: { path: PropertyFiltersPresenter.DEFAULT_URL_PATH }
			},
			{
				label: 'Rua Oscar Freire, Jardins, Itaim Bibi',
				route: { path: PropertyFiltersPresenter.DEFAULT_URL_PATH }
			},
			{
				label: 'Avenida Batel, Ipiranga',
				route: { path: PropertyFiltersPresenter.DEFAULT_URL_PATH }
			}
		]
	},
	{
		name: 'Condomínios',
		links: [
			{
				label: 'Imóveis com Piscina',
				route: PropertyFiltersPresenter.getRouteObjectFromFilters({
					features: [FeatureEnum.POOL]
				})
			},
			{
				label: 'Apartamentos com Varanda Gourmet',
				route: PropertyFiltersPresenter.getRouteObjectFromFilters({
					features: [FeatureEnum.GOURMET_TERRACE]
				})
			},
			{
				// TODO: qual feature representa "Área de Lazer"?
				label: 'Casas com Área de Lazer',
				route: { path: PropertyFiltersPresenter.DEFAULT_URL_PATH }
			},
			{
				// TODO: qual feature representa "Vista para o Mar"?
				label: 'Coberturas com Vista para o Mar',
				route: { path: PropertyFiltersPresenter.DEFAULT_URL_PATH }
			},
			{
				label: 'Casas com piscina',
				route: PropertyFiltersPresenter.getRouteObjectFromFilters({
					propertyTypes: [PropertyTypeEnum.HOUSE],
					features: [FeatureEnum.POOL]
				})
			}
		]
	}
];

export const mainRegions: LinkListItem[] = [
	{
		name: 'Interior',
		links: [
			{
				label: 'Imóveis em Interior - SP',
				route: PropertyFiltersPresenter.getRouteObjectFromFilters({
					states: ['SP'],
					macroregions: ['Interior']
				})
			},
			{
				label: 'Condomínio Fazenda Boa Vista, Porto Feliz',
				route: PropertyFiltersPresenter.getRouteObjectFromFilters({
					regions: ['Condomínio Fazenda Boa Vista'],
					cities: ['Porto Feliz'],
					states: ['SP'],
					macroregions: ['Interior']
				})
			},
			{
				label: 'Quinta da Baroneza, Bragança Paulista',
				route: PropertyFiltersPresenter.getRouteObjectFromFilters({
					regions: ['Quinta da Baroneza'],
					cities: ['Bragança Paulista'],
					states: ['SP'],
					macroregions: ['Interior']
				})
			}
		]
	},
	{
		name: 'Alphaville',
		links: [
			{
				label: 'Imóveis em Alphaville - SP',
				route: PropertyFiltersPresenter.getRouteObjectFromFilters({
					states: ['SP'],
					macroregions: ['Alphaville']
				})
			},
			{
				label: 'Alphaville Empresarial, Barueri',
				route: PropertyFiltersPresenter.getRouteObjectFromFilters({
					regions: ['Alphaville Empresarial'],
					cities: ['Barueri'],
					states: ['SP'],
					macroregions: ['Alphaville']
				})
			},
			{
				label: 'Alphaville Industrial, Barueri',
				route: PropertyFiltersPresenter.getRouteObjectFromFilters({
					regions: ['Alphaville Industrial'],
					cities: ['Barueri'],
					states: ['sp'],
					macroregions: ['Alphaville']
				})
			}
		]
	},
	{
		name: 'Litoral Norte',
		links: [
			{
				label: 'Imóveis em Litoral Norte - SP',
				route: PropertyFiltersPresenter.getRouteObjectFromFilters({
					states: ['SP'],
					macroregions: ['Litoral Norte']
				})
			},
			{
				label: 'Riviera de São Lourenço, Bertioga',
				route: PropertyFiltersPresenter.getRouteObjectFromFilters({
					regions: ['Riviera de São Lourenço'],
					cities: ['Bertioga'],
					states: ['SP'],
					macroregions: ['Litoral Norte']
				})
			},
			{
				label: 'Baleia, Ubatuba',
				route: PropertyFiltersPresenter.getRouteObjectFromFilters({
					regions: ['Baleia'],
					cities: ['Ubatuba'],
					states: ['SP'],
					macroregions: ['Litoral Norte']
				})
			}
		]
	},
	{
		name: 'Litoral Sul',
		links: [
			{
				label: 'Imóveis em Litoral Sul - SP',
				route: PropertyFiltersPresenter.getRouteObjectFromFilters({
					states: ['SP'],
					macroregions: ['Litoral Sul']
				})
			},
			{
				label: 'Iporanga, Guarujá',
				route: PropertyFiltersPresenter.getRouteObjectFromFilters({
					states: ['SP'],
					cities: ['Guarujá'],
					regions: ['Iporanga'],
					macroregions: ['Litoral Sul']
				})
			},
			{
				label: 'Jardim Acapulco, Guarujá',
				route: PropertyFiltersPresenter.getRouteObjectFromFilters({
					states: ['SP'],
					cities: ['Guarujá'],
					regions: ['Jardim Acapulco'],
					macroregions: ['Litoral Sul']
				})
			}
		]
	}
];

export const otherPropertyTypesLinks: LinkListItem[] = [
	{
		name: 'Apartamento',
		image: '/images/properties/apartment_bg.webp',
		links: [
			{
				label: 'Comercial',
				route: PropertyFiltersPresenter.getPathFromFilters({
					propertyTypes: [PropertyTypeEnum.COMMERCIAL]
				})
			},
			{
				label: 'Loft',
				route: PropertyFiltersPresenter.getPathFromFilters({
					propertyTypes: [PropertyTypeEnum.LOFT]
				})
			},
			{
				label: 'Triplex',
				route: PropertyFiltersPresenter.getPathFromFilters({
					propertyTypes: [PropertyTypeEnum.TRIPLEX]
				})
			}
		]
	},
	{
		name: 'Casa',
		image: '/images/properties/house_bg.webp',
		links: [
			{
				label: 'Duplex',
				route: PropertyFiltersPresenter.getPathFromFilters({
					propertyTypes: [PropertyTypeEnum.DUPLEX]
				})
			},
			{
				label: 'Studio',
				route: PropertyFiltersPresenter.getPathFromFilters({
					propertyTypes: [PropertyTypeEnum.STUDIO]
				})
			}
		]
	},
	{
		name: 'Casa de vila',
		image: '/images/properties/villa_house_bg.webp',
		links: [
			{
				label: 'Flat',
				route: PropertyFiltersPresenter.getPathFromFilters({
					propertyTypes: [PropertyTypeEnum.FLAT]
				})
			},
			{
				label: 'Terreno',
				route: PropertyFiltersPresenter.getPathFromFilters({
					propertyTypes: [PropertyTypeEnum.LAND]
				})
			}
		]
	},
	{
		name: 'Cobertura',
		image: '/images/properties/penthouse_bg.webp',
		links: [
			{
				label: 'Garden',
				route: PropertyFiltersPresenter.getPathFromFilters({
					propertyTypes: [PropertyTypeEnum.GARDEN]
				})
			},
			{
				label: 'Terreno em condomínio',
				route: PropertyFiltersPresenter.getPathFromFilters({
					propertyTypes: [PropertyTypeEnum.CONDO_LAND]
				})
			}
		]
	}
];

export const nearRegions: { label: string; route: RouteLocationRaw }[] = [
	{
		label: 'Pinheiros, São Paulo',
		route: {
			path: PropertyFiltersPresenter.getPathFromFilters({
				states: ['sp'],
				cities: ['São Paulo'],
				regions: ['Pinheiros']
			})
		}
	},
	{
		label: 'Vila Madalena, São Paulo',
		route: {
			path: PropertyFiltersPresenter.getPathFromFilters({
				states: ['sp'],
				cities: ['São Paulo'],
				regions: ['Vila Madalena']
			})
		}
	},
	{
		label: 'Itaim Bibi, São Paulo',
		route: {
			path: PropertyFiltersPresenter.getPathFromFilters({
				states: ['sp'],
				cities: ['São Paulo'],
				regions: ['Itaim Bibi']
			})
		}
	},
	{
		label: 'Moema, São Paulo',
		route: {
			path: PropertyFiltersPresenter.getPathFromFilters({
				states: ['sp'],
				cities: ['São Paulo'],
				regions: ['Moema']
			})
		}
	},
	{
		label: 'Ipiranga, São Paulo',
		route: {
			path: PropertyFiltersPresenter.getPathFromFilters({
				states: ['sp'],
				cities: ['São Paulo'],
				regions: ['Ipiranga']
			})
		}
	}
];

export const curatedListRegionsLinks: NavigationSectionItem[] = [
	{
		title: '',
		links: [
			{
				label: 'Apartamentos Itaim Bibi',
				route: PropertyFiltersPresenter.getPathFromFilters({
					states: ['sp'],
					cities: ['São Paulo'],
					regions: ['itaim-bibi'],
					propertyTypes: [PropertyTypeEnum.APARTMENT]
				})
			},
			{
				label: 'Apartamentos Vila Nova Conceição',
				route: PropertyFiltersPresenter.getPathFromFilters({
					states: ['sp'],
					cities: ['São Paulo'],
					regions: ['vila-nova-conceicao'],
					propertyTypes: [PropertyTypeEnum.APARTMENT]
				})
			},
			{
				label: 'Apartamentos Jardim Paulista',
				route: PropertyFiltersPresenter.getPathFromFilters({
					states: ['sp'],
					cities: ['São Paulo'],
					regions: ['jardim-paulista'],
					propertyTypes: [PropertyTypeEnum.APARTMENT]
				})
			}
		]
	},
	{
		title: '',
		links: [
			{
				label: 'Casas Jardim Paulistano',
				route: PropertyFiltersPresenter.getPathFromFilters({
					states: ['sp'],
					cities: ['São Paulo'],
					regions: ['jardim-paulistano'],
					propertyTypes: [PropertyTypeEnum.HOUSE]
				})
			},
			{
				label: 'Apartamentos Jardim Europa',
				route: PropertyFiltersPresenter.getPathFromFilters({
					states: ['sp'],
					cities: ['São Paulo'],
					regions: ['jardim-europa'],
					propertyTypes: [PropertyTypeEnum.APARTMENT]
				})
			},
			{
				label: 'Casas Jardim Europa',
				route: PropertyFiltersPresenter.getPathFromFilters({
					states: ['sp'],
					cities: ['São Paulo'],
					regions: ['jardim-europa'],
					propertyTypes: [PropertyTypeEnum.HOUSE]
				})
			}
		]
	},
	{
		title: '',
		links: [
			{
				label: 'Apartamentos Jardim America',
				route: PropertyFiltersPresenter.getPathFromFilters({
					states: ['sp'],
					cities: ['São Paulo'],
					regions: ['jardim-america'],
					propertyTypes: [PropertyTypeEnum.APARTMENT]
				})
			},
			{
				label: 'Casas Jardim America',
				route: PropertyFiltersPresenter.getPathFromFilters({
					states: ['sp'],
					cities: ['São Paulo'],
					regions: ['jardim-america'],
					propertyTypes: [PropertyTypeEnum.HOUSE]
				})
			},
			{
				label: 'Coberturas Itaim Bibi',
				route: PropertyFiltersPresenter.getPathFromFilters({
					states: ['sp'],
					cities: ['São Paulo'],
					regions: ['itaim-bibi'],
					propertyTypes: [PropertyTypeEnum.PENTHOUSE]
				})
			}
		]
	},
	{
		title: '',
		links: [
			{
				label: 'Coberturas Vila Nova Conceição',
				route: PropertyFiltersPresenter.getPathFromFilters({
					states: ['sp'],
					cities: ['São Paulo'],
					regions: ['vila-nova-conceicao'],
					propertyTypes: [PropertyTypeEnum.PENTHOUSE]
				})
			},
			{
				label: 'Coberturas em São Paulo',
				route: PropertyFiltersPresenter.getPathFromFilters({
					states: ['sp'],
					cities: ['São Paulo'],
					propertyTypes: [PropertyTypeEnum.PENTHOUSE]
				})
			},
			{
				label: 'Apartamentos em São Paulo',
				route: PropertyFiltersPresenter.getPathFromFilters({
					states: ['sp'],
					cities: ['São Paulo'],
					propertyTypes: [PropertyTypeEnum.APARTMENT]
				})
			}
		]
	}
];

export const condoLinks: NavigationSectionItem[] = [
	{
		title: '',
		links: [
			{
				label: 'Apartamentos Itaim Bibi',
				route: PropertyFiltersPresenter.getPathFromFilters({
					states: ['sp'],
					cities: ['São Paulo'],
					regions: ['itaim-bibi'],
					propertyTypes: [PropertyTypeEnum.APARTMENT]
				})
			},
			{
				label: 'Apartamentos Vila Nova Conceição',
				route: PropertyFiltersPresenter.getPathFromFilters({
					states: ['sp'],
					cities: ['São Paulo'],
					regions: ['vila-nova-conceicao'],
					propertyTypes: [PropertyTypeEnum.APARTMENT]
				})
			},
			{
				label: 'Apartamentos Jardim Paulista',
				route: PropertyFiltersPresenter.getPathFromFilters({
					states: ['sp'],
					cities: ['São Paulo'],
					regions: ['jardim-paulista'],
					propertyTypes: [PropertyTypeEnum.APARTMENT]
				})
			}
		]
	},
	{
		title: '',
		links: [
			{
				label: 'Casas Jardim Paulistano',
				route: PropertyFiltersPresenter.getPathFromFilters({
					states: ['sp'],
					cities: ['São Paulo'],
					regions: ['jardim-paulistano'],
					propertyTypes: [PropertyTypeEnum.HOUSE]
				})
			},
			{
				label: 'Apartamentos Jardim Europa',
				route: PropertyFiltersPresenter.getPathFromFilters({
					states: ['sp'],
					cities: ['São Paulo'],
					regions: ['jardim-europa'],
					propertyTypes: [PropertyTypeEnum.APARTMENT]
				})
			},
			{
				label: 'Casas Jardim Europa',
				route: PropertyFiltersPresenter.getPathFromFilters({
					states: ['sp'],
					cities: ['São Paulo'],
					regions: ['jardim-europa'],
					propertyTypes: [PropertyTypeEnum.HOUSE]
				})
			}
		]
	},
	{
		title: '',
		links: [
			{
				label: 'Apartamentos Jardim America',
				route: PropertyFiltersPresenter.getPathFromFilters({
					states: ['sp'],
					cities: ['São Paulo'],
					regions: ['jardim-america'],
					propertyTypes: [PropertyTypeEnum.APARTMENT]
				})
			},
			{
				label: 'Casas Jardim America',
				route: PropertyFiltersPresenter.getPathFromFilters({
					states: ['sp'],
					cities: ['São Paulo'],
					regions: ['jardim-america'],
					propertyTypes: [PropertyTypeEnum.HOUSE]
				})
			},
			{
				label: 'Coberturas Itaim Bibi',
				route: PropertyFiltersPresenter.getPathFromFilters({
					states: ['sp'],
					cities: ['São Paulo'],
					regions: ['itaim-bibi'],
					propertyTypes: [PropertyTypeEnum.PENTHOUSE]
				})
			}
		]
	},
	{
		title: '',
		links: [
			{
				label: 'Coberturas Vila Nova Conceição',
				route: PropertyFiltersPresenter.getPathFromFilters({
					states: ['sp'],
					cities: ['São Paulo'],
					regions: ['vila-nova-conceicao'],
					propertyTypes: [PropertyTypeEnum.PENTHOUSE]
				})
			},
			{
				label: 'Coberturas em São Paulo',
				route: PropertyFiltersPresenter.getPathFromFilters({
					states: ['sp'],
					cities: ['São Paulo'],
					propertyTypes: [PropertyTypeEnum.PENTHOUSE]
				})
			},
			{
				label: 'Apartamentos em São Paulo',
				route: PropertyFiltersPresenter.getPathFromFilters({
					states: ['sp'],
					cities: ['São Paulo'],
					propertyTypes: [PropertyTypeEnum.APARTMENT]
				})
			}
		]
	}
];
